import React from 'react';
import {
  DialogTitle,
  DialogContent,
  Alert,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';
import AppDialog from '../common/AppDialog';
import { Category } from '../../types';
import { useLanguage } from '../../contexts/LanguageContext';

interface DeleteCategoryDialogProps {
  open: boolean;
  onClose: () => void;
  category: Category | null;
  onConfirm: () => Promise<void>;
  isLoading?: boolean;
}

const DeleteCategoryDialog: React.FC<DeleteCategoryDialogProps> = ({
  open,
  onClose,
  category,
  onConfirm,
  isLoading = false,
}) => {
  const { t } = useLanguage();

  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <AppDialog presentation="confirm" open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {t('category.delete')}
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning">
          {t('category.deleteConfirmation').replace('{name}', category?.name || '')}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          {t('common.cancel')}
        </Button>
        <Button
          onClick={handleConfirm}
          color="error"
          variant="contained"
          disabled={isLoading}
          startIcon={isLoading && <CircularProgress size={20} />}
        >
          {t('common.delete')}
        </Button>
      </DialogActions>
    </AppDialog>
  );
};

export default DeleteCategoryDialog;
